import React from 'react'
import { Button, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap'
import Select from 'react-select';

export const FormPrecodedText = (props) => {
    const { toggle, loading, id_type_precoded_text, text, typePrecodedTexts, handleInputChange, validaciones, methodAction, button } = props;
    const { id_type_precoded_text: validacionIdTypePrecodedText, text: validacionText } = validaciones;
    return (
        <Form role="" onSubmit={methodAction}>
            <ModalBody>
                <Row>
                    <FormGroup className='mb-3 col-12' >
                        <Label className="text-sm">Tipo de texto precodificado</Label>
                        <Select
                            classNamePrefix="select"
                            name="id_type_precoded_text"
                            options={typePrecodedTexts.map((u) => ({
                                value: u.id_type_precoded_text,
                                label: u.name
                            }))}
                            value={
                                typePrecodedTexts
                                .map((u) => ({
                                    value: u.id_type_precoded_text,
                                    label: u.name
                                }))
                                .find((opt) => opt.value === id_type_precoded_text) || null
                            }
                            placeholder="Selecciona el tipo de texto precodificado"
                            isClearable={false}
                            onChange={(e) =>
                                handleInputChange({
                                target: { name: "id_type_precoded_text", value: e ? e.value : "" }
                                })
                            }
                             menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }) 
                            }}
                            />

                        <FormFeedback>Debes seleccionar una opción</FormFeedback>
                    </FormGroup>
                    <FormGroup className="mb-3 col-12">
                        <Label className="text-sm">Texto</Label>
                        <Input
                            //placeholder="Texto"
                            className="form-control form-control-sm input-air-primary" 
                            type="text"
                            name="text"
                            value={text}
                            onChange={handleInputChange}
                            required={true}
                            autoComplete="off"
                            invalid={validacionText}
                        />
                        <FormFeedback>El texto debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    outline
                    color="primary"
                    type="submit"
                    className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    {button}
                </Button>
                <Button outline color='danger' type="button" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Form>
    )
}
